var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArJavatimeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 130,
    height: 56,
    viewBox: "0 0 130 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D2172B",
    d: "M128.368 42.17V19.499c0-1.226-1.26-2.476-2.7-2.675L75.732 9.897H54.24L4.32 16.806c-1.404.193-2.688 1.471-2.688 2.675v22.69c0 1.226 1.255 2.47 2.688 2.67l56.231 7.799c2.954.342 5.938.342 8.892 0l56.225-7.8c1.44-.199 2.7-1.443 2.7-2.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CBAB7D",
    d: "M65 55.136c-1.575.014-3.15-.078-4.713-.274l-55.693-7.8C2.06 46.708 0 44.512 0 42.166V19.49c0-2.346 2.061-4.565 4.594-4.902l49.594-6.967h21.675l49.532 6.938c2.538.354 4.605 2.557 4.605 4.902v22.705c0 2.345-2.067 4.565-4.605 4.896l-55.682 7.806c-1.563.194-3.138.283-4.713.268zM54.342 9.87L4.9 16.796c-1.39.194-2.663 1.472-2.663 2.676v22.694c0 1.227 1.244 2.47 2.663 2.67l55.694 7.801c2.925.343 5.88.343 8.807 0l55.687-7.8c1.425-.2 2.675-1.444 2.675-2.67V19.49c0-1.227-1.25-2.477-2.675-2.677L75.63 9.886 54.342 9.87z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M115.905 36.53v-5.237c0-3.529-2.834-6.39-6.329-6.39-3.495 0-6.328 2.861-6.328 6.39v.125l-.636 1.136h1.901c.7 0 1.266-.572 1.266-1.278 0-2.117 1.7-3.834 3.797-3.834 2.097 0 3.797 1.717 3.797 3.834v3.851H98.202v-12.78c0-.706-.567-1.278-1.266-1.278h-1.902l.636 1.136v14.314l-.636 1.136h21.518l-.647-1.125zM31.908 34.888c1.58-2.093 1.72-4.943.354-7.183s-3.96-3.41-6.536-2.951c-2.576.46-4.608 2.455-5.122 5.03h-7.156l.639 1.134v9.189l-.639 1.134h1.91c.699.01 1.274-.547 1.29-1.248v-7.657h3.815v5.105H39.52c.703 0 1.272-.571 1.272-1.276v-1.917l-1.13.64h-7.755zm-5.087 0H22.99V31.06c0-2.112 1.705-3.826 3.81-3.829 2.104-.003 3.814 1.705 3.82 3.818.007 2.112-1.693 3.83-3.798 3.84zM48.494 35.127v-12.78c0-.7-.565-1.269-1.269-1.278h-1.95l.647 1.136v14.314l-.646 1.136h13.507c.71 0 1.286-.572 1.286-1.278v-1.891l-1.143.641H48.494z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.069,
    cy: 39.897,
    r: 1.345,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.103,
    cy: 39.897,
    r: 1.345,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.448,
    cy: 26,
    r: 1.345,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.034,
    cy: 26,
    r: 1.345,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.828,
    cy: 21.966,
    r: 1.345,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.897,
    cy: 39.897,
    r: 1.345,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M90.801 31.293c0-3.529-2.833-6.39-6.328-6.39s-6.329 2.861-6.329 6.39v.125l-.636 1.136h10.779v2.556H73.098V22.347c0-.706-.567-1.278-1.266-1.278h-1.901l.636 1.136v14.314l-.636 1.136h21.517l-.63-1.136-.017-5.226zm-9.912-1.278c.536-1.532 1.971-2.557 3.58-2.557 1.61 0 3.046 1.025 3.582 2.557h-7.162z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M24.103 4H28.103V9H24.103zM2.103 2H23.103V7H2.103z",
    transform: "translate(52.897)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#936E57",
    d: "M12.296 16.825c5.77.02 10.468-4.616 10.497-10.36V4.692h-21v1.773c.033 5.745 4.731 10.38 10.503 10.36z",
    transform: "translate(52.897)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#474847",
    d: "M26.03 2.688h-1.69V1.127C24.34.505 23.836 0 23.214 0H1.126C.504 0 0 .505 0 1.127v5.494c-.006 6 4.352 11.113 10.274 12.054 5.922.942 11.649-2.567 13.503-8.273h2.252c1.413.054 2.742-.669 3.464-1.885.722-1.215.722-2.729 0-3.944-.722-1.216-2.051-1.94-3.464-1.885zM12.192 16.482c-5.475.019-9.932-4.4-9.963-9.878V2.22h19.92v4.384c-.029 5.477-4.484 9.897-9.957 9.878zm13.836-8.3H24.34V4.908h1.69c.607-.036 1.184.268 1.498.79.315.52.315 1.173 0 1.694-.314.522-.891.826-1.499.79z",
    transform: "translate(52.897)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArJavatimeLogo);
export default __webpack_public_path__ + "static/media/ar-javatime-logo.7dd3ba72e39e83b801163e744a760943.svg";
export { ForwardRef as ReactComponent };